/**
 * Арифметика 1ПМ для калькулятора в тренировке.
 *
 * Формула Эпли на сервере живёт в одном месте — `app/domain.epley_1rm`, — и
 * здесь её зеркало, а не второй вариант: калькулятор должен считать ровно так
 * же, как статистика и рекомендации, иначе цифры в зале разойдутся с экраном
 * упражнения. Тест сверяет с числами серверных тестов.
 */

/** Оценка 1ПМ по подходу: вес × (1 + повторы / 30). */
export const epley1rm = (weight: number, reps: number): number => weight * (1 + reps / 30);

/** Обратная задача: какой вес пойдёт на N повторов при данном 1ПМ. */
export const weightForReps = (oneRm: number, reps: number): number => oneRm / (1 + reps / 30);

/** Повторы для таблицы «вес на N раз». За 12 формула Эпли уже врёт. */
export const REP_TARGETS = [2, 3, 4, 5, 6, 8, 10, 12] as const;

/** Проценты для таблицы «доля от 1ПМ» — как в программах с %1ПМ. */
export const PERCENTS = [95, 90, 85, 80, 75, 70, 65, 60] as const;

/** Выше этого оценка по Эпли ненадёжна — калькулятор предупреждает. */
export const RELIABLE_REPS = 12;
